import customizeValidator from "./customizeValidator";

export { customizeValidator };
export * from "./types";

export default customizeValidator();
